import { Link2 } from 'lucide-react';
import { KEEP_LINE } from '@/lib/keepLink';

/**
 * The standing line (lib/keepLink.js, Ryan 2026-10-26): keep the footage link, and the files in it, until the first
 * draft, because we edit straight from it and keep no copy. One look wherever it shows: the client's board, the
 * project, the order confirmation and the order form. NEUTRAL on purpose (the site look's colour rule: static marks are
 * neutral, ember is for warnings only): it is advice, not an alarm. Neutral classes rather than the gold note the order
 * form uses, because the board column does not translate a static gold the way a site-look page does (it read amber
 * there in the 2026-10-26 check). The caller decides whether it applies (keepsLink(project); the link field on the
 * order form).
 */
export default function KeepFootageLink({ testId = 'keep-footage-link', className = '' }) {
  return (
    <div data-testid={testId} className={`flex items-start gap-2.5 p-3 rounded-md bg-ug-raised border border-ug-border text-left ${className}`}>
      <Link2 className="w-4 h-4 text-slate-400 shrink-0 mt-0.5" aria-hidden="true" />
      <p className="text-[12px] leading-relaxed text-zinc-300">{KEEP_LINE}</p>
    </div>
  );
}
